import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import BuyOrSwap from './components/BuyOrSwap/BuyOrSwap';
import Features from './components/Features/Features';
import PayBills from './components/PayBills/PayBills';
import Help from './components/Help/Help';
import Footer from './components/Footer/Footer';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <Router>
      <AppContent isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
    </Router>
  );
}

const AppContent = ({ isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    setIsLoggedIn(true);
    navigate('/dashboard');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    navigate('/');
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <>
            <Header isLoggedIn={isLoggedIn} handleLogout={handleLogout} />
            <Hero />
            <BuyOrSwap />
            <Features />
            <PayBills />
            <Help />
            <Footer />
          </>
        } />
        <Route path="/login" element={<Login handleLogin={handleLogin} />} />
        <Route path="/dashboard" element={
          isLoggedIn ? <Dashboard handleLogout={handleLogout} /> : <Login handleLogin={handleLogin} />
        } />
      </Routes>
    </div>
  );
};

export default App;
